// Test IDs for home / landing page

export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  navHome: "nav-home-link",
  navInternet: "nav-internet-link",
  navTwinTv: "nav-twintv-link",
  navNoc: "nav-noc-link",
  navCloud: "nav-cloud-link",
  navAbout: "nav-about-link",
  navSupport: "nav-support-link",
  navCoverageMap: "nav-coverage-map-link",
  navContact: "nav-contact-link",
  clientPortalButton: "client-portal-button",
  mobileMenuButton: "mobile-menu-button",
  languageSwitchAr: "language-switch-ar",
  languageSwitchEn: "language-switch-en",
  heroCoverageCta: "hero-coverage-cta",
  heroExploreCta: "hero-explore-services-cta",
  heroTwinTvDownloadCta: "hero-twin-tv-download-cta",
  heroWhatsAppButton: "hero-whatsapp-button",
  heroCallButton: "hero-call-button",
  statCard: "stats-card",
  serviceCard: "internet-service-card",
  coveragePreviewCard: "coverage-preview-card",
  twinTvDownloadButton: "twin-tv-download-button",
  twinTvLearnMoreButton: "twin-tv-learn-more-button",
  nocDashboardButton: "noc-dashboard-button",
  networkStatusItem: "network-status-item",
  networkStatusValue: "network-status-value",
  contactWhatsappButton: "contact-whatsapp-button",
  contactForm: "contact-form",
  contactNameInput: "contact-form-name-input",
  contactPhoneInput: "contact-form-phone-input",
  contactServiceSelect: "contact-form-service-select",
  contactMessageTextarea: "contact-form-message-textarea",
  contactSubmitButton: "contact-form-submit-button",
  contactSupportButton: "contact-support-button",
  footerSocialLink: "footer-social-link",
  headerWhatsappButton: "header-whatsapp-button",
  headerCallButton: "header-call-button",
};
